import { render, staticRenderFns } from "./editor-get-changes-error-dialog.vue?vue&type=template&id=3fad90e2&scoped=true"
import script from "./editor-get-changes-error-dialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./editor-get-changes-error-dialog.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./editor-get-changes-error-dialog.vue?vue&type=style&index=0&id=3fad90e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fad90e2",
  null
  
)

export default component.exports